import angular from 'angular';
import uiRouter from 'angular-ui-router';
import charCountTextareaComponent from './charCountTextarea.component';

let charCountTextareaModule = angular.module('charCountTextarea', [
  uiRouter
])

.component('charCountTextarea', charCountTextareaComponent)

.name;

export default charCountTextareaModule;
